/* global FB */
// TODO: need to remove library
import Ractive from '../modules/ractive'
import bindAll from 'lodash/bindAll'
import { getParameterByName } from './index'

const spiral = window.spiral
let instance = null

export default class Login {
  static run () {
    return (instance = (instance || new Login()))
  }

  static instance () {
    return instance || (instance = new Login())
  }

  constructor () {
    if (Number(getParameterByName('linkedin-callback')) === 1) {
      window.opener.linkedinAuthorized(getParameterByName('code'), getParameterByName('state'))
    }

    bindAll(this, ['fbAuthDataPass', 'socialDataProcess', 'showLoginPopup'])
    window.showLoginPopup = this.showLoginPopup
    window.lib.loginModal = this.showLoginPopup
    window.callbackAuthorize = result => {
      if (result.response.status === 200 && result.response.state === 'authorized') {
      } else {
        (result.response.showActivationButton) ? this.ractive.set('showActivationButton', true) : this.ractive.set('showActivationButton', false)
      }
    }

    window.callbackLinking = result => {
      if (result.response && result.response.state && result.response.state === 'replaceLink') {
        this.ractive.set('accountStep', 'changeSocialAccount')
      }

      if (result.response.status === 200 && result.response.state === 'linked') {
        this.ractive.set({
          accountStep: 'connectedWithSocialSuccess',
          chainURL: result.response.chainURL,
        })
      } else {
        (result.response.showActivationButton) ? this.ractive.set('showActivationButton', true) : this.ractive.set('showActivationButton', false)
      }
    }

    window.resetPasswordCallback = result => {
      if (result.response.status === 200) {
        this.ractive.set({ resetPassword: 'resetPasswordSuccess' })
      }
    }

    window.linkedinAuthorized = (code, state) => {
      window.linkedinPopup.close()
      spiral.ajax({
        url: '/linkedin/accept',
        data: {
          code,
          state,
          refresh: 1,
          hash: this.ractive.get('hash'),
          isLogin: 1,
          initialURL: location.href,
        },
        processAnswer: this.socialDataProcess,
      })
    }
  }

  showLoginPopup () {
    this.ractive = new Ractive({
      el: document.body,
      append: true,
      template: '#tpl-sign-form',
      data: {
        url: location.pathname + location.search,
        type: 'sign',
        accountStep: 'login',
        resetPassword: 'enterEmail',
        activeSocialNetwork: '',
        chainURL: '',
      },
      onrender () {

      },
    })

    this.ractive.on('close', () => {
      this.ractive.teardown()
    })

    this.ractive.on('phoneKeypress', event => {
      if (!((event.original.charCode >= 48 && event.original.charCode <= 57) || event.original.charCode === 43 || event.original.charCode === 45 || event.original.keyCode === 8)) { return false }
    })

    this.ractive.on('phoneInput', event => {
      event.node.value = event.node.value.replace(/[^0-9+-]/g, '')
    })

    this.ractive.on('facebook-login', (e, type) => {
      if (typeof FB === 'undefined') { return }

      FB.login(response => {
        if (response.status === 'connected') {
          this.fbAuthDataPass(response, type)
        } else if (response.status === 'not_authorized') {
          console.error('The person is logged into Facebook, but not your app.')
        } else {
          console.error('The person is not logged into Facebook, so we are not sure if they are logged into this app or not.')
        }
      }, {
        scope: 'email',
        return_scopes: true,
      })
      this.ractive.set('activeSocialNetwork', 'Facebook')
    })

    this.ractive.on('linkedin-login', () => {
      window.linkedinPopup = window.open('about:blank', 'LinkedIn login', 'height=300,width=350')
      const t = this

      spiral.ajax({
        url: '/linkedin/loginurl',
        processAnswer (r) {
          if (r.response.status === 200 && r.response.state === 'loginURL') {
            t.ractive.set('hash', r.response.hash)
            window.linkedinPopup.location.replace(r.response.url)
          }
        },
      })
      this.ractive.set('activeSocialNetwork', 'LinkedIn')
    })

    this.ractive.on('replaceLink', () => {
      const t = this

      spiral.ajax({
        url: '/replaceLink/',
        data: {
          hash: this.ractive.get('hash'),
          refresh: 1,
          initialURL: location.href,
        },
        processAnswer (result) {
          if (result.response.status === 200 && result.response.state === 'authorized') {
            t.ractive.teardown()
          }
        },
      })
    })

    this.ractive.on('preserveLink', () => {
      const t = this

      spiral.ajax({
        url: '/preserveLink/',
        data: {
          hash: this.ractive.get('hash'),
          refresh: 1,
          initialURL: location.href,
        },
        processAnswer (result) {
          if (result.response.status === 200 && result.response.state === 'authorized') {
            t.ractive.teardown()
          }
        },
      })
    })

    this.ractive.on('chainRedirect', () => {
      window.location.href = this.ractive.get('chainURL')
    })
  }

  fbAuthDataPass (response, type) {
    spiral.ajax({
      url: '/facebook',
      data: {
        facebook: response.authResponse,
        isLogin: type === 'signin' ? 1 : 0,
        refresh: 1,
        initialURL: location.href,
      },
      processAnswer: this.socialDataProcess,
    })
  }

  socialDataProcess (r) {
    if (r.response.status !== 200) { return }

    const obj = {
      userData: r.response.data,
      elbUser: r.response.user,
      hash: r.response.hash,
    }

    switch (r.response.state) {
      case 'signup':
        obj.createAccountStep = 'signUpBasic'
        break
      case 'suggestion':
        obj.accountStep = 'suggestion'
        break
      case 'linking':
        obj.accountStep = 'linking'
        break
      case 'authorized':
        obj.isAuthorized = 1
        obj.step = 'billing'
        break
      default:
        obj.createAccountStep = 'signUpBasic'
        break
    }

    this.ractive.set(obj)
  }
}
